module.exports = __webpack_public_path__ + "static/media/widget-placeholder.9d68669b.jpg";